import { AIF_LOGIN_FAIL, AIF_LOGIN_RESPONSE, RESET_FORGOT_PASSWORD_AIF_RESPONSE, RESET_FORGOT_PASSWORD_AIF_FAIL } from '../redux/types/aifLogin'
import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import UserApi from "../services/userApi";
import AppApi from "../services/appApi";
let api = new UserApi();
let api2 = new AppApi()


export function* AIFDistibutorLogin({ type, resolve, payload }) {

    let responsePayload = {};
    let error = {}

    try {
        let { data } = yield api.AIFDistibutorLogin(payload);

        console.log("PMSDistibutorLogin Response", data)
        if (data.success) {
            responsePayload = data.data;
            yield put({ type: AIF_LOGIN_RESPONSE, payload: responsePayload })
            yield put(push('/dashboard'));
            resolve && resolve(responsePayload)
        } else {
            error = data
            console.log("PMSDistibutorLogin error", error)
            yield put({ type: AIF_LOGIN_FAIL, payload: error })
            resolve && resolve(data)
        }

    } catch (e) {
        console.log("Error Pms", e)
        yield put(push('/dashboard'));
        yield put({ type: AIF_LOGIN_FAIL })
        resolve && resolve(e)

    }
}

export function* ResetForgetPasswordAIF({ type, resolve, payload }) {

    let responsePayload = {};

    try {
        let { data } = yield api.ResetForgetPasswordAIF(payload);

        if (data.success) {
            responsePayload = data;
            yield put({ type: RESET_FORGOT_PASSWORD_AIF_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        } else {
            yield put({ type: RESET_FORGOT_PASSWORD_AIF_FAIL })
            resolve && resolve(data)
        }

    } catch (e) {
        yield put({ type: RESET_FORGOT_PASSWORD_AIF_FAIL })
        resolve && resolve(e)

    }
}
